import type { Category } from '@/payload-types'

/**
 * Build the URL for a category nav link / card.
 *
 * SEO fix (2026-07-26): navigation and the homepage category grid used to
 * hardcode `/shop?category=${id}` for every category link — every category
 * page in the header, homepage "Kategorien" grid, and mobile menu. Meanwhile
 * the site *also* has clean, indexable slug routes for categories (e.g.
 * `/de/cannabis-stecklinge`, handled by `[locale]/[slug]/page.tsx`), but
 * nothing ever linked to them internally. That left them essentially
 * orphaned from Google's perspective — no internal links, and previously not
 * in the sitemap either. Point nav links at the slug route instead so the
 * pages we actually want to rank for things like "cannabis stecklinge wien"
 * get real internal link equity.
 *
 * Falls back to the old `/shop?category=${id}` query-string form when a
 * category doesn't have a resolvable slug (e.g. only a bare numeric ID was
 * stored, not a populated relationship) so nothing breaks if depth/population
 * ever changes upstream.
 */
export function getCategoryHref(
  categoryId: number | string | Category | null | undefined,
  fallbackUrl?: string | null,
): string {
  if (categoryId && typeof categoryId === 'object') {
    if (categoryId.slug) return `/${categoryId.slug}`
    return `/shop?category=${categoryId.id}`
  }
  if (categoryId) {
    return `/shop?category=${categoryId}`
  }
  return fallbackUrl || '#'
}
